exports = module.exports = require("../../node_modules/.0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{position:relative;min-height:100%;background-color:#fff}body{margin-bottom:40px}.c-foot{position:absolute;margin:0;left:0;bottom:0;width:100%;padding:10px 0;text-align:center;color:#696969}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.26.4@css-loader?minimize!./~/.10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-55236381!./~/.10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer.vue
// module id = 45
// module chunks = 1